

























import { computed, defineComponent } from '@vue/composition-api';

const name = 'ttam-identity-tiktok-post-authorize-search-input';

export default defineComponent({
  name,
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    smbTea: {
      type: Object,
      required: false,
      default: () => ({ enter: '', search: '' }),
    },
  },
  setup(props, { emit }) {
    const curVal = computed({
      get: () => props.value,
      set: (val: string) => {
        emit('input', val);
      },
    });
    const onSearch = () => {
      emit('search', curVal.value);
      emit('search-auth-video', props.smbTea.search);
    };
    const handleTeaReport = () => {
      emit('search-auth-video', props.smbTea.enter);
    };
    const onInput = (val: string) => {
      curVal.value = val;
    };

    return {
      name,
      curVal,
      onInput,
      onSearch,
      handleTeaReport,
    };
  },
});
